import { schema } from 'normalizr';

const schemaEntity = new schema.Entity('consumer');

export default schemaEntity;
